import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBa68nhPVJw8pxdGqS48eRlDT0eQRCrreI",
  authDomain: "portfolio-8dda4.firebaseapp.com",
  projectId: "portfolio-8dda4",
  storageBucket: "portfolio-8dda4.firebasestorage.app",
  messagingSenderId: "276116625954",
  appId: "1:276116625954:web:58ed8904c2691497a8087b"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

export const submitContactForm = async (formData) => {
  try {
    const docRef = await addDoc(collection(db, "contacts"), {
      ...formData,
      createdAt: serverTimestamp()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};